import API from './api';

export const authService = {
  // 1. Sign up
  signUp: async (email, password, firstName, lastName) => {
    try {
      const response = await API.post('/api/trips/admin/email/signup', {
        email,
        password,
        firstName,
        lastName
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Sign up failed. Please try again.',
        error: error.response?.data
      };
    }
  },

  // 2. Confirm sign up with OTP
  confirmSignUp: async (email, confirmationCode) => {
    try {
      const response = await API.post('/api/trips/admin/email/confirm-signup', {
        email,
        confirmationCode
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Verification failed. Please try again.',
        error: error.response?.data
      };
    }
  },

  // 3. Resend confirmation code
  resendConfirmationCode: async (email) => {
    try {
      const response = await API.post('/api/trips/admin/email/resendConfirmationCode', {
        email
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to resend code. Please try again.',
        error: error.response?.data
      };
    }
  },

  // 4. Login
  login: async (email, password) => {
    try {
      const response = await API.post('/api/trips/admin/email/login', {
        email,
        password
      });
      
      if (response.data.success) {
        // Store tokens in localStorage
        const { access_token, id_token, refresh_token, user } = response.data.data;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('id_token', id_token);
        localStorage.setItem('refresh_token', refresh_token);
        localStorage.setItem('user', JSON.stringify(user));
      }
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed. Please try again.',
        error: error.response?.data
      };
    }
  },

  // 5. Forgot password - request reset code
  forgotPassword: async (email) => {
    try {
      const response = await API.post('/api/trips/admin/email/forgotPasswordCode', {
        email
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to send reset code. Please try again.',
        error: error.response?.data
      };
    }
  },

  // 6. Confirm forgot password with code
  confirmForgotPassword: async (email, newPassword, confirmationCode) => {
    try {
      const response = await API.post('/api/trips/admin/email/cofirmForgetPassword', {
        email,
        newPassword,
        confirmationCode
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Password reset failed. Please try again.',
        error: error.response?.data
      };
    }
  },

  // 7. Logout
  logout: () => {
    localStorage.clear();
    window.location.href = '/login';
  }
};
